import React, { useState , useEffect} from "react";
import { CalendarClock, ChevronDown, ChevronUp } from "lucide-react";
import { useNavigate } from "react-router-dom";
import './../css/HomeAttendance.css';
import axios from "./../../axios";
const StaffAttendanceHome = ({ open, setOpen}) => {
    const navigate = useNavigate();
    const [present,setPresent] = useState(1);
    const [leave,setLeave] = useState(1);
    const [absent,setAbsent] = useState(1);
    
useEffect(() => {
  const fetchProfile = async () => {
    try {
      const staff = JSON.parse(localStorage.getItem("staff")); // or pass from props/context

      const response = await axios.get('staff/get_home_attandence', {
        params: {
          id:staff.id
        },
      });
 
      console.log(response.data);
       setPresent(response.data.present);
       setLeave(response.data.leave);
       setAbsent(response.data.absent);

    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  fetchProfile();
}, []);
 const safeValue = (value) => {
  return value && value.trim() !== '' ? value : '--';
};
    return (
        <div className="attendance-container">
            <div className="attendance-toggle" onClick={() => setOpen(!open)}>
                <div className="left">
                    <div className="icon-wrapper">
                        <CalendarClock size={20} />
                    </div>
                    <span className="title">Attendance Report</span>
                </div>
                {open ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </div>

            {open && (
                <div className="attendance-details">
                    <div className="attendance-row present">
                        <span>✅ Present</span>
                        <b>{present}</b>
                    </div>
                    <div className="attendance-row leave">
                        <span>🌴 Leave</span>
                        <b>{leave}</b>
                    </div>
                    <div className="attendance-row absent">
                        <span>❌ Absent</span>
                        <b>{absent}</b>
                    </div>
                    <button className="calendar-link" onClick={() => navigate('/staff/attendance_teacher')}>
                        📅 View Full Calendar
                    </button>
                </div>
            )}
        </div>
    );
};

export default StaffAttendanceHome;
